module.exports = __webpack_public_path__ + "img/pr-2.aa1fcbff.png";